module.exports = __webpack_public_path__ + "static/media/icon-lolol-mall.447595ac.png";